import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { GroupsSettingsRoute } = lazily(() => import("./GroupsSettingsRoot"));

/** The /settings/access-control/groups index route: see GroupsSettingsRoot. */
export const groupsSettingsRoute: PreloadingRouteProps = {
  element: <GroupsSettingsRoute />,
  loader: lazyRouteLoader({
    load: () =>
      import("./groupsSettingsPreload").then((module) =>
        module.createGroupsSettingsLoader(),
      ),
    warm: () => import("./GroupsSettingsRoot"),
  }),
  // The directory keeps itself up to date while it is mounted: a search, a
  // page, the provider filter and the view toggle are handled in place, and a
  // change of grouping is written to the URL and loaded by the grid itself, so
  // none of them needs the loader to run again.
  shouldRevalidate: () => false,
};
